export default __webpack_public_path__ + "static/media/clock.63f9750f.jpg";